import { render, staticRenderFns } from "./carrouselRecenSearch.vue?vue&type=template&id=59711bba"
import script from "./carrouselRecenSearch.vue?vue&type=script&lang=js"
export * from "./carrouselRecenSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports